import ListItemsType from "./ListItemsType";

interface Employee extends ListItemsType {
    fullName: string;
    email: string;
    phone: string;
    location: string;
    title: string;
    title_2: string;
    imageURL: string;
    imageThumbnailURL: string;
}

export const isEmployee = (item: any): boolean => {
    return !!(item as Employee).fullName;
};

export default Employee;